import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import Spinner from "../components/UI/Spinner/Spinner.component";
import Detail from "../components/detail.component";
import http from "../http";

const ArticleDetail = ({ match }) => {
  const { articleID } = match.params;
  const [data, setData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await http.get(`/article/${articleID}`);
        setData(result.data);
      } catch (err) {
        console.log(err);
      }
    };
    fetchData();
  }, [articleID]);
  const content = !data.length ? <Spinner /> : <Detail article={data[0]} />;
  return content;
};
export default withRouter(ArticleDetail);
